const jobCandidateInteraction = {
  id: '',
  applicationStage: '',
  applicationState: '',
  candidateNotes: [{ notes: '', createdBy: '', createdAt: '' }],
  stageAndStateActions: [
    {
      stage: '',
      state: '',
      id: '',
      updatedBy: '',
      updatedOn: new Date().toString(),
    },
  ],
  stageDate: new Date().toString(),
  candidateId: '',
  name: '',
  page: 0,
};
export default jobCandidateInteraction;
